<template>
  <div class="feedback-detail">
    <!-- 问题反馈 -->
    <img src="../../assets/feedback/bg.jpg" class="img" />
    <div class="toast"><span>正在跳转中...</span></div>
  </div>
</template>
<script>
export default {
  name: "feedbackCenter",
  data() {
    return {
      openId: "",
      code:''
    };
  },
  mounted() {},
  created() {
    this.getOpenId();
  },
  methods: {
    getOpenId() {
      this.openId = localStorage.getItem("feedBackOpenId") || "";
      // this.code = localStorage.getItem("code_center") || "";
      console.log(this.openId,'feedBackOpenId')
      let url = `${process.env.VUE_APP_BASE_API}?source=wechat-official-account&openId=${this.openId}`;
      if (this.openId) {
        window.location.replace(url);
      }
    },
  },
};
</script>

<style>
.feedback-detail {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
}

.feedback-detail .img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}

.feedback-detail .toast {
  /* margin-top: 10px;  */
  color: #6666;
  font-size: 18px;
}
</style>
